import * as swcHelpers from '@swc/helpers';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { mapServerToSunglassesVariant } from '../variant-mappers/map-server-to-sunglasses-variant.js';
import { mapServerToProductBase } from './map-server-to-product-base.js';

const mapServerToSunglassesProduct = (serverProduct, slug, locale, facetConfigList, priceSegmentChannelKey)=>{
    if ((serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.__typename) !== 'SunglassesProduct') {
        return {
            failure: 'incorrect-typename',
            message: `Expected SunglassesProduct for slug "${slug}", but got ${serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.__typename}`
        };
    }
    const variants = mapServerToSunglassesVariant(serverProduct, slug, locale, priceSegmentChannelKey);
    if (!variants || variants.length === 0) {
        return {
            failure: 'no-variants',
            message: `Cannot return Sunglasses product with slug: "${slug}" because it has no variants`
        };
    }
    var _isExclusiveBrand;
    const sunglasses = swcHelpers.objectSpread({}, mapServerToProductBase(serverProduct, variants, facetConfigList), {
        productType: 'Sunglasses',
        variants,
        isOfferedWithPrescriptions: !!serverProduct.productTypeDetails.isOfferedWithPrescriptions,
        isExclusiveBrand: (_isExclusiveBrand = serverProduct.productTypeDetails.isExclusiveBrand) !== null && _isExclusiveBrand !== void 0 ? _isExclusiveBrand : undefined
    });
    return sunglasses;
};

export { mapServerToSunglassesProduct };
//# sourceMappingURL=map-server-to-sunglasses-product.js.map
